module.exports = "<span *ngIf=\"enumListObj.hasOwnProperty(enumValue)\">{{enumListObj[enumValue]}}</span>\n"